import {
  Link,
  LinkField,
  Text,
  TextField,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { getCombinedStyles } from '../../helpers/Providers/bokfDefaultClassNameProvider';

interface Fields {
  data: {
    datasource: {
      url: {
        path: string;
        siteName: string;
      };
      field: {
        jsonValue: {
          value: string;
          editable?: string;
          metadata?: { [key: string]: unknown };
        };
      };
    };
    contextItem: {
      url: {
        path: string;
        siteName: string;
      };
      field: {
        jsonValue: {
          value: string;
          editable?: string;
          metadata?: { [key: string]: unknown };
        };
      };
    };
  };
}

type TitleProps = {
  params: { [key: string]: string };
  fields: Fields;
};

const TitleDefault = (props: TitleProps): JSX.Element => (
  <div
    className={`bokf-component title ${getCombinedStyles(
      props.params.GridParameters,
      props.params.Styles
    )}`.replace(/\[object Object\]/g, '')}
  >
    <div className="component-content">
      <span className="is-empty-hint">Title</span>
    </div>
  </div>
);

export const Default = (props: TitleProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();

  if (props.fields) {
    const datasource = props.fields?.data?.datasource || props.fields?.data?.contextItem;
    const id = props.params.RenderingIdentifier;
    const styles = getCombinedStyles(props.params.GridParameters, props.params.Styles);

    // Get PageTitle from route fields - cast to TextField
    const pageTitleField = sitecoreContext?.route?.fields?.PageTitle as TextField;
    const pageTitle = String(pageTitleField?.value || '');

    const text: TextField = {
      value: pageTitle,
      editable: pageTitleField?.editable,
    };

    const link: LinkField = {
      value: {
        href: datasource?.url?.path || '#',
        title: pageTitle,
      },
    };

    if (sitecoreContext.pageState !== 'normal') {
      link.value.querystring = `sc_site=${datasource?.url?.siteName}`;
      if (!text?.value) {
        text.value = 'Title field';
        link.value.href = '#';
      }
    }

    return (
      <div
        className={`bokf-component title ${styles}`.replace(/\[object Object\]/g, '')}
        id={id || undefined}
      >
        <div className="component-content">
          <div className="field-title">
            {sitecoreContext.pageEditing ? (
              <Text field={text} />
            ) : (
              <Link field={link}>
                <Text field={text} />
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <TitleDefault {...props} />;
};
